export default "__VITE_ASSET__Dut$OzqT__"